import React, { useEffect, useState } from 'react';
import './Certifications.css';
import { Certification } from '../types';
import { getCertifications } from '../queries/getCertifications';
// Corrected imports for same-folder location

import UdemyIcon from './icons/UdemyIcon';
import CourseraIcon from './icons/CourseraIcon';
import IeeeIcon from './icons/IeeeIcon';
import UniversityIcon from './icons/UniversityIcon';
import ExternalLinkIcon from './icons/ExternalLinkIcon';

// This object now uses your new local components
const iconData: { [key: string]: JSX.Element } = {
  'udemy': <UdemyIcon />,
  'coursera': <CourseraIcon />,
  'ieee': <IeeeIcon />,
  'university': <UniversityIcon />
}

const Certifications: React.FC = () => {
  const [certifications, setCertifications] = useState<Certification[]>([]);

  useEffect(() => { 
    async function fetchCertifications() {
      const data = await getCertifications();
      setCertifications(data);
    }
    fetchCertifications();
  }, []);

  if (certifications.length === 0) return <div>Loading...</div>;

  return (
    <div className="certifications-container">
      <div className="certifications-grid">
        {certifications.map((cert, index) => (
          <a href={cert.link} key={index} target="_blank" rel="noopener noreferrer" className="certification-card" style={{ '--delay': `${index * 0.2}s` } as React.CSSProperties}>
            <div className="certification-content">
              {/* This line now correctly uses the fallback UniversityIcon component */}
              <div className="certification-icon">{iconData[cert.iconname] || <UniversityIcon />}</div>
              <h3>{cert.title}</h3>
              <p>{cert.issuer}</p>
              {cert.issueddate && <span className="issued-date">Issued {cert.issueddate}</span>}
            </div>
            <div className="certification-link animated-icon">
              {/* The hardcoded icon is now replaced with your local component */}
              <ExternalLinkIcon />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Certifications;